import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { appSettings } from '../../environments/app-settings';

export const versionInterceptor: HttpInterceptorFn = versionInterceptorInternal;

function versionInterceptorInternal(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const request = req.url.startsWith(appSettings.api.url) ? req.clone({
    headers: req.headers.set('x-syk-client-version', appSettings.version)
  }) : req;

  return next(request);
}
